"use client";

import React from "react";
import Image from "next/image";
import Link from "next/link";
import { RiExternalLinkFill } from "react-icons/ri";
import { FaYoutube, FaStar } from "react-icons/fa";
import { MdOutlineOndemandVideo } from "react-icons/md";

const FreeCard = ({
  hero,
  title,
  facultyName,
  url,
}) => {
  return (
    <div className="course-card">
      {/* Card image with overlay and badges */}
      <div className="card-image-container">
        <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 to-transparent z-10"></div>
        <Image
          src={hero}
          alt={title}
          width={500}
          height={300}
          className="card-image"
        />
        {/* Free Badge */}
        <div className="absolute top-4 left-4 z-20">
          <span className="bg-yellow-500 px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wide shadow-md text-white">
            Free
          </span>
        </div>
        {/* YouTube Icon */}
        <div className="absolute bottom-4 right-4 z-20">
          <FaYoutube className="text-red-600 text-3xl bg-white rounded-full p-1" />
        </div>
      </div>
      
      <div className="card-content">
        {/* Title */}
        <h3 className="card-title">{title}</h3>
        
        {/* Faculty */}
        {facultyName && (
          <div className="flex items-center text-sm text-gray-600 mb-3">
            <span className="font-medium">Instructor:</span>
            <span className="ml-2 text-gray-700 truncate">{facultyName}</span>
          </div>
        )}
        
        {/* Rating */}
        <div className="flex items-center mb-3">
          <div className="flex">
            {[...Array(5)].map((_, i) => (
              <FaStar key={i} className="text-amber-400 w-4 h-4" />
            ))}
          </div>
          <span className="ml-2 text-xs text-gray-600">5.0 (Free Course)</span>
        </div>
        
        {/* Course Stats */}
        <div className="flex items-center text-sm text-gray-600 mb-4">
          <MdOutlineOndemandVideo className="mr-1" />
          <span>Full Playlist</span>
        </div>
        
        <div className="card-footer">
          <Link href={url} target="_blank" className="explore-button">
            Explore Course
            <RiExternalLinkFill className="button-icon" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FreeCard;
